export default "__VITE_ASSET__FZNs9FOR__"